import React from 'react';
import PageTitle from '../PageTitle';
import Spacer from '../Spacer';
import TutorialContent from '../TutorialsPage/TutorialContent';
import AdvanceButton from '../TutorialsPage/AdvanceButton';
import { TutorialsProvider } from '../TutorialsPage/TutorialsContext';
import '../TutorialsPage/styles.css';

interface PracticeRoundIntroProps {
  onContinue: () => void;
}

const PracticeRoundIntroContent = () => {
  const bodyTextStyle: React.CSSProperties = {
    fontSize: '1.5em',
    color: '#444',
    textAlign: 'center',
    maxWidth: 880,
    lineHeight: 1.5,
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '100px 0',
        minHeight: '40vh',
      }}
    >
      <div
        style={{
          fontSize: '2.5em',
          fontWeight: 700,
          marginBottom: 32,
          textAlign: 'center',
          color: '#1976d2',
        }}
      >
        <span role="img" aria-label="game controller" style={{ fontSize: '1.2em', marginRight: 12 }}>
          🎮
        </span>
        Now, let's try a practice round together!
      </div>
      <div style={{ ...bodyTextStyle, marginBottom: 20 }}>
        Play one round against a{' '}
        <span role="img" aria-label="dice">🎲</span>{' '}
        <strong style={{ color: '#ff1a1a' }}>random computer player</strong>. That player&apos;s investment is chosen
        completely at random, and <strong>independent of your investment</strong>.
      </div>
      <div style={bodyTextStyle}>
        Use this round to get familiar with the slider and <strong>Invest</strong> button, and to see how
        investments affect the outcome <strong>before the real game</strong>.
      </div>
    </div>
  );
};

const PracticeRoundIntro: React.FC<PracticeRoundIntroProps> = ({ onContinue }) => {
  return (
    <TutorialsProvider>
      <div className="container">
        <PageTitle title="Tutorial" />
        <Spacer />
        <TutorialContent>
          <PracticeRoundIntroContent />
        </TutorialContent>
        <Spacer />
        <AdvanceButton onAdvance={onContinue} />
      </div>
    </TutorialsProvider>
  );
};

export default PracticeRoundIntro;
